export default __webpack_public_path__ + "static/media/scarves.70930c32.jpg";